// components/common/Footer.jsx
import React from 'react';
import { useTranslation } from 'react-i18next';

function Footer() {
  const { t, i18n } = useTranslation();
  const currentYear = new Date().getFullYear();
  
  const mainSiteUrl = 'https://simpleclass.eu';
  const currentLang = i18n.language || 'en';

  return (
    <footer className="w-full bg-white border-t border-slate-100">
      <div className="max-w-6xl mx-auto px-4 py-8 flex flex-col items-center space-y-4">
        <div className="flex flex-wrap justify-center gap-x-8 gap-y-2">
          <a 
            href="https://admin.simpleclass.eu/login"
            className="text-sm text-slate-600 hover:text-cyan-600 transition duration-200"
          >
            {t('footer.adminLogin')}
          </a>
          <a 
            href={`${mainSiteUrl}/${currentLang}/privacy`}
            className="text-sm text-slate-600 hover:text-cyan-600 transition duration-200"
          >
            {t('footer.privacy')}
          </a>
          <a 
            href={`${mainSiteUrl}/${currentLang}/terms`}
            className="text-sm text-slate-600 hover:text-cyan-600 transition duration-200"
          >
            {t('footer.terms')}
          </a>
          <a 
            href={`${mainSiteUrl}/${currentLang}/contact`}
            className="text-sm text-slate-600 hover:text-cyan-600 transition duration-200"
          >
            {t('footer.contact')}
          </a>
        </div>
        <p className="text-sm text-slate-400">
          {t('footer.copyright', { year: currentYear })}
        </p>
      </div>
    </footer>
  );
}

export default Footer;